<template>
  <div>
    <div v-show="errorMessage" class="uk-alert-danger" uk-alert>
      <p>{{ errorMessage }}</p>
    </div>
    <h4 class="uk-margin-remove-top" v-show="repay.fullname">
      {{ repay.fullname }}
    </h4>
    <label
        class="uk-margin-small-bottom uk-flex"
        :for="i"
        v-for="(loan, i) in repay.loans"
        :key="i"
        @click="select(i)">
      <div><input :id="i" type="radio" :checked="selected(i)" class="uk-radio"></div>
      <div class="uk-margin-small-left">{{ loan["contract"] }}</div>
    </label>
    <form @submit.prevent="submit"
          class="uk-form-stacked uk-margin-top"
          id="mbk_form">
      <fieldset class="uk-fieldset">
        <label for="amount" class="uk-form-label">{{ $t("repay.amount") }}</label>
        <div class="uk-form-controls">
          <div class="uk-inline uk-width-1-1">
            <span class="uk-form-icon-flip uk-form-icon" uk-icon="tag"></span>
            <input id="amount"
                   @input="setAmount"
                   :value="form.amount"
                   type="text"
                   inputmode="numeric"
                   class="uk-input">
          </div>
        </div>
        <small class="uk-text-danger" v-html="form.flattenErrors('amount')"></small>
      </fieldset>
      <fieldset class="uk-fieldset">
        <button type="submit" class="uk-button uk-button-primary uk-width-1-1">
          {{ buttonCaption }}
          <span v-if="processing" uk-spinner="ratio: 0.75"></span>
        </button>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { AmountForm } from "@/utils/RepayForm";
import { mapGetters } from "vuex";

export default {
  name: "RepaySelectForm",
  data() {
    return {
      form: new AmountForm(),
      loan: null,
      processing: false,
      errorMessage: ""
    };
  },
  methods: {
    setAmount(e) {
      this.form.setAmount(e);
    },
    select(i) {
      this.loan = this.repay.loans[i];
      this.form = new AmountForm(this.loan["repay_amount"]);
      this.errorMessage = "";
    },
    selected(i) {
      if (!this.loan) return false;
      return this.repay.loans[i]["contract_id"] === this.loan["contract_id"];
    },
    submit() {

      // if (this.form.amount > 150000) {
      //     this.errorMessage = this.$t("wrong_amount");
      //     return;
      // }

      if (this.loan === null) {
        this.errorMessage = this.$t("choose_loan");
        return;
      }
      this.form.validate();
      if (!this.form.isValid || this.processing) return;
      this.processing = true;
      const params = {
        amount: Number(this.form.amount),
        token: this.loan.token
      };
      this.$http.post("/repay-ru/iframe-uri/", params)
          .then(res => {
            this.$parent.done(res.data);
          })
          .catch(err => {
            this.errorMessage = err.response.data.message;
          }).then(() => this.processing = false);
    }
  },
  computed: {
    ...mapGetters(["repay"]),
    buttonCaption() {
      if (this.processing) {
        return "";
      }
      return this.$t("continue");
    }
  }
};
</script>